/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Vue from "vue";
import Vuex from "vuex";
import vueSmoothScroll from "vue-smooth-scroll";
import VueI18n from "vue-i18n";
import Meta from "vue-meta";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
Vue.use(VueAwesomeSwiper);
Vue.use(vueSmoothScroll);
Vue.use(VueI18n);
Vue.use(Vuex);
Vue.use(Meta);

export default Vue;
